import { useWarehouseTaskWorkspace } from "./useWarehouseTaskWorkspace";
import type { WarehouseTaskProps } from "./useWarehouseTaskWorkspace";
import { WarehouseTaskView } from "./WarehouseTaskView";
export function WarehouseTaskCard(props: WarehouseTaskProps) {
 const workspace = useWarehouseTaskWorkspace(props);
 return <WarehouseTaskView task={props.task} workspace={workspace} />;
}
